module.exports = __webpack_public_path__ + "img/374.9797e20c.svg";